import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { authClient } from "~/lib/auth";
import { isOffboarded } from "~/lib/customer-status";

export const Route = createFileRoute("/(authenticated)")({
  component: Outlet,
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession();
    const user = session.data?.user;

    // If no session, redirect to login. The page that was asked for rides
    // along so the OTP round-trip lands back on it (a deep link into the
    // mandate step, for instance) instead of on the bare dashboard.
    if (!user) {
      throw redirect({ to: "/inloggen", search: { redirect: location.href } });
    }
    // Deactivated or deleted customers keep their login (see the Deactivate flow)
    // but must not see their old dashboard, chargers or payout details. Checked
    // BEFORE the onboarding redirect: an offboarded customer with isOnboarded
    // still true would otherwise fall straight through to the dashboard.
    if (isOffboarded(user.status)) {
      throw redirect({ to: "/account-inactief" });
    }

    // If session exists but user is not onboarded, redirect to onboarding step 1
    if (!user.isOnboarded) {
      throw redirect({ to: "/onboarding/$step", params: { step: "provider-selection" } });
    }

    // re-return to update type as non-null for child routes
    return { user };
  },
});
